<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" :label-width="80" inline>
          <FormItem label="日志类型">
            <Dict v-model="form.logtype" dict="log_type" :need-all="true"></Dict>
          </FormItem>
          <FormItem label="日志名称">
            <Input v-model="form.logname"></Input>
          </FormItem>
          <FormItem label="是否成功">
            <Dict v-model="form.succeed" dict="yes_no" :need-all="true"></Dict>
          </FormItem>
        </Form>
        <div class="toolbar">
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns"/>
    </Card>
  </div>
</template>

<script>

export default {
  name: 'operationlog-list',
  data () {
    return {
      columns: [
        { title: '日志类型', key: 'logtype', dict: 'log_type' },
        { title: '操作', key: 'message' },
        { title: '日志名称', key: 'logname' },
        { title: '用户ID', key: 'userid' },
        { title: '类名称', key: 'classname' },
        { title: '方法名称', key: 'method' },
        { title: '创建时间', key: 'createtime' },
        { title: '是否成功', key: 'succeed', dict: 'yes_no' }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      var param = {
        page: page,
        pageSize: pageSize,
        sort: 'createTime',
        model: this.form,
        map: this.form.map
      }
      this.L('admin/operationlog', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
